import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import { services } from '../../services';

export const useGetCollection = (params = {}) =>
  useQuery(
    createQueryKey(QUERY_KEYS.useGetCollectionKey, params),
    () => services.detail(params?.collectionId),
    {
      enabled: !!params?.collectionId
    }
  );
